import { Customer } from "./customer"
import { Tenant } from "./tenant"
import { UserResponse } from "@/api/UserService"
import { UsersResponse } from "@/api/UsersService"
import { PageRoutes } from "@/constants/routes"

export enum UserRole {
   ADMIN = "admin",
   MANAGEMENT = "management",
   GUARD = "guard",
}

export enum UserStatus {
   ACTIVE = "Active",
   ACTIVE_MFA_BYPASSED = "Active (MFA bypassed)",
   INACTIVE = "Inactive",
   EXPIRED = "Invitation expired",
   PENDING = "Invitation pending",
}

export enum Feature {
   CELL_MAINTENANCE = "cell-maintenance",
   EXPORT = "export",
   TEST_ALARM_TRIGGER = "test-alarm-trigger",
}

export const rolePermissions: Record<UserRole, (PageRoutes | Feature)[]> = {
   admin: [
      PageRoutes.FLOOR_OVERVIEW,
      PageRoutes.CELL_DETAIL_OVERVIEW,
      PageRoutes.INMATE_DETAIL_OVERVIEW,
      PageRoutes.SETTINGS,
      Feature.CELL_MAINTENANCE,
   ],
   management: [
      PageRoutes.FLOOR_OVERVIEW,
      PageRoutes.CELL_DETAIL_OVERVIEW,
      PageRoutes.INMATE_DETAIL_OVERVIEW,
   ],
   guard: [PageRoutes.FLOOR_OVERVIEW],
}

interface UserFacility {
   id: string
   name: string
   role: UserRole | null
}

interface UserCustomer {
   id: Customer["id"]
   name: Customer["name"]
   facilities: UserFacility[]
   role: UserRole | null
}

export interface UserTenant {
   id: Tenant["id"]
   name: Tenant["name"]
   customers: UserCustomer[]
   role: UserRole | null
}

export interface BaseUser {
   email: string
   firstName: string
   lastName: string
}

export type CurrentUser = UserResponse
export type User = UsersResponse
